(function () {
    var hq = document.querySelector('.hq');
    if (!hq) return;
    var html = document.documentElement;
    var toggle = hq.querySelector('[data-hq-toggle]');
    var desktopMq = window.matchMedia('(min-width: 1024px)');

    // 1. is-scrolled toggle (ALL templates): home frosts, and every page morphs into the floating pill past 50px
    var onScroll = function(){ hq.classList.toggle('is-scrolled', window.scrollY > 50); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // 1b. Sit just below the announcement bar; snap to top:0 as it scrolls away. All pages.
    var hqAnn = document.querySelector('[data-announcement-bar]');
    var hqPositionTop = function(){
      if (!hqAnn){ document.documentElement.style.setProperty('--hq-top', '0px'); return; }
      var r = hqAnn.getBoundingClientRect();
      // --hq-top = the bar's live bottom edge (header follows it, snaps to 0 as it scrolls away)
      document.documentElement.style.setProperty('--hq-top', Math.max(0, r.bottom) + 'px');
      // --hq-ann-h = the bar's height (used on the homepage to pull the hero up behind it)
      document.documentElement.style.setProperty('--hq-ann-h', r.height + 'px');
    };
    hqPositionTop();
    window.addEventListener('scroll', hqPositionTop, { passive: true });
    window.addEventListener('resize', hqPositionTop, { passive: true });

    // 2. mobile drawer open/close
    function setDrawer(open){
      hq.classList.toggle('open', open);
      html.classList.toggle('hq-no-scroll', open);
      if (toggle){
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      }
    }
    if (toggle){ toggle.addEventListener('click', function(){ setDrawer(!hq.classList.contains('open')); }); }

    // 3. desktop mega — click/touch fallback (hover + focus handled by CSS)
    var megaItems = hq.querySelectorAll('.hq__nav-item--mega');
    megaItems.forEach(function(item){
      var trigger = item.querySelector('.hq__nav-trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function(e){
        e.preventDefault();
        var willOpen = !item.classList.contains('is-open');
        megaItems.forEach(function(o){ o.classList.remove('is-open'); var t=o.querySelector('.hq__nav-trigger'); if(t) t.setAttribute('aria-expanded','false'); });
        item.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
    // 3b. featured-card image carousels — crossfade the section photos while the mega is open (hover/focus)
    megaItems.forEach(function(item){
      var card = item.querySelector('.hq__mega-card--carousel');
      if (!card) return;
      var slides = card.querySelectorAll('.hq__mega-slide');
      if (slides.length < 2) return;
      var idx = 0, timer = null;
      function tick(){ idx = (idx + 1) % slides.length; slides.forEach(function(s, k){ s.classList.toggle('is-active', k === idx); }); }
      function start(){ if (!timer) timer = setInterval(tick, 2600); }
      function stop(){ clearInterval(timer); timer = null; }
      item.addEventListener('mouseenter', start);
      item.addEventListener('mouseleave', stop);
      item.addEventListener('focusin', start);
      item.addEventListener('focusout', stop);
    });
    // close a mega when the mouse leaves it, and on scroll (so click/tap-opened panels don't stick open)
    megaItems.forEach(function(item){
      item.addEventListener('mouseleave', function(){
        item.classList.remove('is-open');
        var t = item.querySelector('.hq__nav-trigger'); if (t) t.setAttribute('aria-expanded', 'false');
      });
    });
    window.addEventListener('scroll', function(){
      megaItems.forEach(function(o){ if (o.classList.contains('is-open')){ o.classList.remove('is-open'); var t=o.querySelector('.hq__nav-trigger'); if(t) t.setAttribute('aria-expanded','false'); } });
    }, { passive: true });
    document.addEventListener('click', function(e){
      if (!e.target.closest('.hq__nav')){ megaItems.forEach(function(o){ o.classList.remove('is-open'); var t=o.querySelector('.hq__nav-trigger'); if(t) t.setAttribute('aria-expanded','false'); }); }
    });

    // 4. mobile accordion
    hq.querySelectorAll('.hq__acc-trigger').forEach(function(trigger){
      trigger.addEventListener('click', function(){
        var item = trigger.closest('.hq__acc-item');
        if (!item) return;
        var willOpen = !item.classList.contains('is-open');
        hq.querySelectorAll('.hq__acc-item').forEach(function(o){ if(o!==item){ o.classList.remove('is-open'); var t=o.querySelector('.hq__acc-trigger'); if(t) t.setAttribute('aria-expanded','false'); } });
        item.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    // 5. Escape closes drawer + any open mega
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape'){
        if (hq.classList.contains('open')) setDrawer(false);
        megaItems.forEach(function(o){ o.classList.remove('is-open'); var t=o.querySelector('.hq__nav-trigger'); if(t) t.setAttribute('aria-expanded','false'); });
      }
    });

    // 6. close drawer when a link inside it is clicked
    var drawer = hq.querySelector('.hq__drawer');
    if (drawer){ drawer.addEventListener('click', function(e){ if (e.target.closest('a')) setDrawer(false); }); }

    // 7. reset when crossing breakpoint
    function onMq(){
      if (desktopMq.matches){
        setDrawer(false);
        hq.querySelectorAll('.hq__acc-item').forEach(function(o){ o.classList.remove('is-open'); });
      } else {
        megaItems.forEach(function(o){ o.classList.remove('is-open'); var t=o.querySelector('.hq__nav-trigger'); if(t) t.setAttribute('aria-expanded','false'); });
      }
    }
    if (desktopMq.addEventListener) desktopMq.addEventListener('change', onMq);
    else if (desktopMq.addListener) desktopMq.addListener(onMq);

    // 8. predictive search — shared engine used by BOTH the desktop modal and the mobile drawer
    function sEsc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]; }); }
    function sMoney(v){ var n = parseFloat(v); return isNaN(n) ? '' : '$' + n.toFixed(2); }

    // Wire an <input> to render live suggestions into a results element. Returns { run, hint }.
    function hqSuggest(input, results, form, opts){
      opts = opts || {};
      var action = (form && form.getAttribute('action')) || '/search';
      var suggestUrl = ((form && form.getAttribute('data-suggest-url')) || '/search/suggest') + '.json';
      var controller = null, debounce = null, lastQ = null;

      function allHref(q){ return action + '?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last'; }
      function hint(){ results.innerHTML = opts.hint === false ? '' : '<p class="hq__sr-hint">Start typing to search products, collections and pages.</p>'; }

      function run(q){
        if (controller) controller.abort();
        controller = ('AbortController' in window) ? new AbortController() : null;
        var url = suggestUrl + '?q=' + encodeURIComponent(q)
          + '&resources[type]=product,collection,page'
          + '&resources[limit]=6'
          + '&resources[options][unavailable_products]=last'
          + '&resources[options][fields]=title,product_type,variants.title,vendor';
        fetch(url, controller ? { signal: controller.signal } : undefined)
          .then(function(r){ return r.ok ? r.json() : null; })
          .then(function(data){ if (data) render(data, q); })
          .catch(function(){ /* aborted or network error — ignore */ });
      }

      function render(data, q){
        var res = (data && data.resources && data.resources.results) || {};
        var products = res.products || [], collections = res.collections || [], pages = res.pages || [];
        var out = '';
        if (products.length){
          out += '<div class="hq__sr-group"><span class="hq__sr-label">Products</span>';
          products.slice(0, 6).forEach(function(p){
            var img = (p.featured_image && p.featured_image.url) || p.image || '';
            var thumb = img ? '<img class="hq__sr-thumb" src="' + img + '" alt="" loading="lazy" width="52" height="52">' : '<span class="hq__sr-thumb"></span>';
            var pr = parseFloat(p.price != null ? p.price : p.price_min);
            var cmp = parseFloat(p.compare_at_price_min || p.compare_at_price_max || 0);
            var priceHtml = sMoney(pr);
            if (cmp && pr && cmp > pr){ priceHtml = '<s>' + sMoney(cmp) + '</s><span class="hq__sr-sale">' + sMoney(pr) + '</span>'; }
            var vendor = p.vendor ? '<span class="hq__sr-vendor">' + sEsc(p.vendor) + '</span>' : '';
            out += '<a class="hq__sr-item" href="' + p.url + '">' + thumb
              + '<span class="hq__sr-body"><span class="hq__sr-title">' + sEsc(p.title) + '</span>' + vendor + '</span>'
              + '<span class="hq__sr-price">' + priceHtml + '</span></a>';
          });
          out += '</div>';
        }
        if (collections.length){
          out += '<div class="hq__sr-group"><span class="hq__sr-label">Collections</span>';
          collections.slice(0, 3).forEach(function(c){
            out += '<a class="hq__sr-link" href="' + c.url + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18"/></svg>' + sEsc(c.title) + '</a>';
          });
          out += '</div>';
        }
        if (pages.length){
          out += '<div class="hq__sr-group"><span class="hq__sr-label">Pages</span>';
          pages.slice(0, 3).forEach(function(pg){
            out += '<a class="hq__sr-link" href="' + pg.url + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/></svg>' + sEsc(pg.title) + '</a>';
          });
          out += '</div>';
        }
        if (!out){
          results.innerHTML = '<p class="hq__sr-empty">No matches for &ldquo;' + sEsc(q) + '&rdquo;.<br><a href="' + allHref(q) + '">Search anyway &rarr;</a></p>';
          return;
        }
        out += '<a class="hq__sr-all" href="' + allHref(q) + '"><span>See all results for &ldquo;' + sEsc(q) + '&rdquo;</span><span aria-hidden="true">&rarr;</span></a>';
        results.innerHTML = out;
      }

      input.addEventListener('input', function(){
        var q = input.value.trim();
        if (q === lastQ) return; lastQ = q;
        window.clearTimeout(debounce);
        if (q.length < 2){ if (controller) controller.abort(); hint(); return; }
        debounce = window.setTimeout(function(){ run(q); }, 200);
      });

      return { run: run, hint: hint };
    }

    // 8a. desktop search modal (opens over the page)
    var searchm = hq.querySelector('[data-hq-searchm]');
    if (searchm){
      var mForm = searchm.querySelector('form');
      var mInput = searchm.querySelector('[data-hq-search-input]');
      var mResults = searchm.querySelector('[data-hq-search-results]');
      searchm.hidden = false; // JS now controls visibility purely via the .is-open class
      var mApi = hqSuggest(mInput, mResults, mForm);

      var sOpen = function(){
        searchm.classList.add('is-open');
        html.classList.add('hq-no-scroll');
        window.setTimeout(function(){ if (mInput){ mInput.focus(); mInput.select(); } }, 30);
        var q = mInput ? mInput.value.trim() : '';
        if (q.length >= 2){ mApi.run(q); } else { mApi.hint(); }
      };
      var sClose = function(){
        searchm.classList.remove('is-open');
        html.classList.remove('hq-no-scroll');
        if (mInput) mInput.blur();
      };

      hq.querySelectorAll('[data-hq-search-open]').forEach(function(o){ o.addEventListener('click', function(e){ e.preventDefault(); sOpen(); }); });
      searchm.querySelectorAll('[data-hq-search-close]').forEach(function(b){ b.addEventListener('click', sClose); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && searchm.classList.contains('is-open')) sClose(); });
    }

    // 8b. mobile drawer — same live results rendered inline beneath the search field
    var dForm = hq.querySelector('[data-hq-drawer-search]');
    if (dForm){
      var dInput = dForm.querySelector('[data-hq-search-input]');
      var dResults = hq.querySelector('[data-hq-drawer-results]');
      if (dInput && dResults){ hqSuggest(dInput, dResults, dForm, { hint: false }); }
    }
  })();
